import React from 'react';
import { NavLink } from 'react-router-dom';
import '@features/Layout/Footer/Footer.scss';
import { AlpLogo } from '@helpers/imagePreloader';
import { footerPages, sitepages, footerSubsites, socmed } from '@features/Layout/utils/constants';
import Image from '@components/Image/Image';
import { subsiteThemes } from '@project/helpers/constants';

function Footer() {

  const getMenu = (): JSX.Element[] => {
    return footerPages.map((item: any, key: number) => {
      if (!item.is_protected) {
        return (
          <li key={key} onClick={item?.urlPath ? () => window.open(item?.urlPath, '_self') : () => {}}>
            <NavLink to={item.urlPath}>{item.displayName}</NavLink>
          </li>
        );
      } else {
        return <React.Fragment key={key}></React.Fragment>;
      }
    });
  };

  const getSubsitesMenu = (): JSX.Element[] => {
    return footerSubsites.map((item: any, key: number) => {
      const { color } = subsiteThemes.get(item.short_code) ?? [];

      return (
        <li key={key}>
          <a href={item.url} className={color} onClick={item?.url ? (e) => { e.preventDefault();  window.open(item?.url, '_self'); } : () => {}}>
            {item.name}
          </a>
        </li>
      );
    });
  };

  const getSubsitePages = (): JSX.Element[] => {
    return sitepages.map((item: any, key: number) => {
      return (
        <li key={key} onClick={item?.url ? () => window.open(item?.url, '_self') : () => {}}>
          <NavLink to={item?.url}>{item?.name}</NavLink>
        </li>
      );
    });
  };

  const getSocMed = (): JSX.Element[] => {
    return socmed.map((item: any, key: number) => {
      return (
        <li key={key} className="clickable" onClick={() => window.open(item?.url, '_blank')}>
          <i className={`icon icon-${item?.icon}`} />
        </li>
      );
    });
  };

  return (
    <footer className="main-footer flex flex-col">
      <div className={`foot-links-row flex flex-row`}>
        <div className="brand-col">
          <Image src={AlpLogo} alt="A Learning Place logo" />
          <p>
            Research and Curriculum & Syllabus-based Mathematical
            <br />
            Teaching and Learning Resources
          </p>
        </div>

        <div className="site-pages-col">
          {/* <h6>Site Pages</h6> */}
          <ul>{getSubsitePages()}</ul>
        </div>

        <div className="subsites-col">
          {/* <h6>Subsites</h6> */}
          <div>
            <ul>{getSubsitesMenu()}</ul>
          </div>
        </div>

        <div className="menu-col">
          {/* <h6>Main Menu</h6> */}
          <ul>{getMenu()}</ul>
        </div>

        <div className="soc-med-col">
          <h6 className="text-center">Socials</h6>
          <ul>{getSocMed()}</ul>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
